
import HeroCarousel from '../components/HeroCarousel'
import VIP from '../components/VIP'
import AboutUsSection from '../components/AboutSection'
import LatestNewsMarquee from './LatestNewsMarquee'
import EventsSection from './EventsSection'
import QuickButton from '../components/QuickButton'
import Facilities from '../components/Facilities'
import CTA from '../components/CTA'
import GallerySlide from '../components/GallerySlide'
import { useSelector } from 'react-redux'
import './Doc.css'

function Home() {


  // const eventsList = [
  //   ['Rover Rangers',
  //     'https://campus.acetians.in/custom/images/rover1.png',
  //     '',
  //     '/events/rover-rangers'
  //   ],
  //   ['Community Outreach Programs(NSS)',
  //     'https://campus.acetians.in/custom/images/nss1.png',
  //     '',
  //     '/events/nss'
  //   ],
  //   ['Green Globe Club',
  //     'https://campus.acetians.in/custom/images/green-globe.png',
  //     '',
  //     '/events/green-globe-club'
  //   ]

  // ];

  const store = useSelector((state) => state.auth.store);
  const quicklinks = [
    {
      'name': 'Exams',
      'image': 'https://content.acetians.in/backup/uploads/autodidact.png',
    },
    {
      'name': 'Admissions',
      'image': 'https://content.acetians.in/backup/uploads/admission%20(1).png',
    },
    {
      'name': 'Results',
      'image': 'https://content.acetians.in/backup/uploads/rankings.png',
    },
    {
      'name': 'Students',
      'image': 'http://content.acetians.in/backup/uploads/education%20(1).png',
    },
    {
      'name': 'University',
      'image': 'https://content.acetians.in/backup/uploads/mortarboard.png',
    },
    {
      'name': 'Academics',
      'image': 'https://content.acetians.in/backup/uploads/academic.png',

    }
  ]
  const events = [
    {
      title: "पाँच दिवसीय रोवर्स-रेंजर्स प्रशिक्षण एवं जांच शिविर काआयोजन",
      link: "#",
      image: "#",
      date: "March 11, 2024",
    },
    {
      title: "राष्ट्रीय सेवा योजना के अंतर्गत सप्तदिवसीय विशेष शिविर संबंधित सूचना",
      link: "#",
      image: "#",
      date: "February 19, 2024",
    },
  ];

  const nextEvents = [
    {
      title: "पाँच दिवसीय रोवर्स-रेंजर्स प्रशिक्षण एवं जांच शिविर काआयोजन",
      link: "#",
      date: "March 11, 2024",
    },
    {
      title: "राष्ट्रीय सेवा योजना के अंतर्गत सप्तदिवसीय विशेष शिविर संबंधित सूचना",
      link: "#",
      date: "February 19, 2024",
    },
    {
      title: "Job Fair from Regional Employment Office Gorakhpur",
      link: "#",
      date: "April 22, 2023",
    },
  ];


  const vipList = [
    {
      name: "Smt. Anandiben Mafatbhai Patel",
      Role: "Hon’ble Chancellor & H.E. Governor of U.P.",
      img: "https://content.acetians.in/backup/uploads/Smt.%20AnandibenMafatbhai%20Patel.jpg"
    },
    {
      name: "Sri Yogi Adityanath Ji",
      Role: "Hon’ble Chief Minister of U.P.",
      img: "https://content.acetians.in/backup/uploads/yogi.jpg"
    },
    {
      name: "Sri Yogendra Upadhyay",
      Role: "Higher Education Minister",
      img: "https://content.acetians.in/backup/uploads/Sri%20Yogendra%20Upadhyay.jpg"
    },
    {
      name: "Smt. Rajni Tiwari",
      Role: "Minister of State (Higher Education)",
      img: "https://content.acetians.in/backup/uploads/Smt.%20Rajni%20Tiwari.jpeg"
    }

  ]
  return (
    <div>
      <div className='d-flex w-100' style={{ maxWidth: '100vw' }}>
        <div className='col-md-9 p-0' style={{ padding: 0 }}>
          <HeroCarousel />
        </div>
        <div className='col-md-3'>
          <ul style={{ padding: '0px', margin: '0px' }}>
            {vipList.map((vip) => (<VIP key={vip.name} chancellor={vip} />))}
          </ul>
        </div>
      </div>
      <LatestNewsMarquee item={store.marquee} />

      <ul id="quicklinks-ul">
        {quicklinks.map((link, index) => (<QuickButton key={index} link={link} />))}
      </ul>

      <AboutUsSection
        title="Welcome to"
        subtitle={store.store_title.split("=")[0]}
        description={"The college is affiliated to Bundelkhand University, Jhansi (UP). Because of the only government college of Science and Commerce in Lalitpur district, affectionate relation between students and teachers and tradition of quality education, it attracts students for higher education in friendly environment. Presently, there are two faculties of Science and Commerce with students, teaching staff and administrative/technical/supporting staff. There is faculty of science with five departments - Botany, Chemistry, Mathematics, Physics and Zoology, and faculty of Commerce with UG & PG Programs. The college is affiliated for B.Sc. Degree (Graduate Course) in Bio Group-Botany, Zoology, Chemistry and Mathematics group, Mathematics Group-Physics, Mathematics, Chemistry and B.Com. The M.Sc. (Post Graduate Course) in Botany, Chemistry, Mathematics, Physics and Zoology and M.Com courses started from 2013 academic session. The College also recognized under 2f & 12B of UGC Act. "}

        //  description1={"The college has a total land area of 14.36 acres out of which the built-up area is 8899.11sq. meters. There are nine lecture rooms, four well-equipped laboratories, examination room, games room, NSS room playground, badminton court etc. There is a central library having a collection of 17,457 books and journals. Located in a rural area and catering to the needs of students belonging to different sections of society for more than twenty-nine years, the college has earned an esteemed reputation and is making notable contribution in the development of people and society."}

        eContentLink="/e-pathshalas/"
        feedbackLink="#"
        path={"/about/about-us"}
        imageUrl={store.about_image}
      />

      <EventsSection events={events} nextEvents={nextEvents} />

      <AboutUsSection
        title="PRINCIPAL"
        name="Prof. (Dr.) Keshav Dev, Principal"
        path={"/administration/principals-message"}
        subtitle="MESSAGE"
        // description={`${store.principal_message}`}
        description={"Dear parents, teachers and students, I extend to you all a very warm welcome to Raghuveer Singh Government Degree College, Lalitpur Website. I hope that this initiation to website will assist in enhancing the college culture furthering the college’s growth and evolution, enabling it to interface with the networked world for efficiency and effectiveness."}

        description1={"Teaching and learning offers us all numerous opportunities to focus on a number of “small things” that culminate over time to produce students who are prepared to do the “great things” of life."}
        eContentLink=""
        feedbackLink=""
        imageUrl={`https://campus.acetians.in/custom/images/${store.principal_image}`}
      />
      <div className='document-section'>
        <div>


        </div>
        <ul>

          <li>  
              <h2>Samiti</h2>
              <iframe title='Samiti' src="https://content.acetians.in/backup/uploads/%E0%A4%B8%E0%A4%AE%E0%A4%BF%E0%A4%A4%E0%A4%BF%202025-26%2019-Jul-2025%2014-42-19.pdf"
              style={{ width: "100%", height: "100%" }} frameborder="0"></iframe>
          </li>
          <li>
              <h2>Gyanpathik</h2>
              <iframe title='Gyanpathik' src="https://content.acetians.in/backup/uploads/Gyanpathik%20complete%20pdf.pdf"
              style={{ width: "100%", height: "100%" }} frameborder="0"></iframe>
          </li>
        </ul>



      </div>
      <Facilities />



      <CTA />
      <GallerySlide />
    </div>
  )
}

export default Home
